<template>
  <div>
    <q-card class="marginTag">
      <q-card-section>
        <div class="titleCard">Imágenes y datos</div>
        <div v-if="this.dataIndicador.datosGraficaMunicipal.valoresGrafica.length<=0" class="noData col-12">NO HAY DATOS DISPONIBLES</div>
        <div v-else class="row">
          <div class=" col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div :class="arrayRasters.length<=0?'text-center': ''">
              <div v-if="arrayRasters.length>0" class="row">
                <div class="divMap col-md-6 col-xs-12">

                <Map
                  keyConfig="WgUrAN6BBGKZAAtFhFPe"
                  showLayerSelector
                  :showLayers="['Basic', 'Satelite']"
                  :coords="coords"
                  :rasters="arrayRastersFiltered.length>0?arrayRastersFiltered:arrayRasters"
                  :wk="wk"
                  :urlGeoServer="urlGeoServer"
                  :rangeTimeLineArray="arrayDatesToMapFiltered.length>0?arrayDatesToMapFiltered:datesToMapFormated"
                  :positionRange ="arrayRastersFiltered.length>0?arrayRastersFiltered.length-1:arrayRasters.length -1"
                  :geoJsonData="geoJsonData"
                  @updateHistoryZoneSelected="updateHistoryZoneSelected"
                />
                </div>

                <!--leyenda-->
                <div v-if="this.dataIndicador.leyenda" class="divLegend col-12 row">
                  <div class="itemLegend" v-for="item in this.dataIndicador.leyenda" v-bind:key="item.id">
                    <div class="colorLegend" :style="`background-color: ${item.color}`"></div>
                    <div v-if="item.value && item.value!==' '" class="valueLegend">{{item.value}}</div>
                      <div :style="checkSomeItemWithNombre()?'height: 102px; word-wrap: break-word;':'display:none'">{{item.nombre}}</div>
                      <div class="divImgLegend" v-if="item.image" :style="item.image?'':'display:none'">
                        <q-img
                          class="imageLegend"
                          v-if="item.image"
                          :src="require(`@/assets/img/leyenda/${item.image}`)"
                          :alt="item.image"
                          containver
                        >
                        </q-img>
                      </div>
                  </div>
                </div>

              </div>
              <div v-else class="noData col-12">NO HAY DATOS DISPONIBLES</div>
          </div>
          </div>
          <div class="col-md-6 col-sm-12 row grafic">
            <div class="grafico col-12">
              <GraficaMunicipioIndicador :dataIndicador="indicador" :datosObjetivo="datosObjetivo" />
            </div>
            <!--btón volver municipio-->
            <q-btn v-if="showBottonBackMunicipio" class="bBack" flat @click="getDataZona(false, idMunicipio)">
              <img
                class="icon-back"
                :src="require('@/assets/img/icono-volver.svg')"
                alt="Icono volver"
              />
              VOLVER A MUNICIPIO
            </q-btn>
            <!--listado zonas-->
            <div class="col-12 col-sm-12 desglose">
              <div class="titleDesglose">
                Zonas
              </div>
              <div class= "row rowDesglose">
                <span v-for="zona in arrayZonas" :key="zona.nombre">
                  <span class="desgloseText cursor-pointer" @click="getDataZona(true, zona.id)">
                    {{formatNameZona(zona.nombre.toUpperCase())}}
                    <span class='zonaValor' v-if='zona.ultimoValor != undefined'>
                      {{parseFloat(zona.ultimoValor).toFixed(2)}} {{unidadMedidaIndicador}}
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
    <DialogCreate
      v-model="showDialog"
      labelSuccess="Cerrar"
      :showBottonCancel="false"
      @save="aceptar()"
    >
      <template slot="body">
        <div class="noDataDialog title-option text-center">
          {{msgDialog}}
        </div>
      </template>
    </DialogCreate>
    </div>
</template>
<script>
import GraficaMunicipioIndicador from '../components/GraficaMunicipioIndicador.vue';
import Map from '@plataforma-legacy/quasar-ui-plataforma-component-vue-library/src/components/map/Map.vue';
import 'leaflet/dist/leaflet.css';
import moment from 'moment';
import { QImg } from 'quasar';
import * as types from '@/storeModules/NGUD/types';
import { mapGetters } from 'vuex';
import DialogCreate from '@/shared/dialogs/create/DialogCreate.vue';

export default {
  components: {
    GraficaMunicipioIndicador,
    Map,
    QImg,
    DialogCreate
  },
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData'
    })
  },
  props: {
    dataIndicador: Object
  },
  watch: {
    dataIndicador () {
      this.indicador = this.dataIndicador;
      this.fillData();
    }
  },
  created () {
    this.indicador = this.dataIndicador;
    if (this.dataIndicador.hasOwnProperty('limitesMunicipio')) this.idMunicipio = this.dataIndicador.limitesMunicipio.id;
    this.unidadMedidaIndicador = this.dataIndicador.unidadMedida;

    if (this.dataIndicador.hasOwnProperty('datoObjetivo')) {
      this.datosObjetivo = { datoObjetivo: this.dataIndicador.datoObjetivo, fechaDatoObjetivo: this.dataIndicador.fechaDatoObjetivo, unidadMedida: this.dataIndicador.unidadMedida };
    }
    if (this.dataIndicador.datosGraficaMunicipal.valoresGrafica.length > 0) {
      let dateInicioSimple = this.dataIndicador.fechaInicio.split('T');
      let dateFinSimple = this.dataIndicador.fechaFin.split('T');
      this.fechaInicioMunicipal = moment(dateInicioSimple[0]).format('YYYY/MM/DD');
      this.fechaFinMunicipal = moment(dateFinSimple[0]).format('YYYY/MM/DD');
      this.geoJsonData = this.dataIndicador.geoJsonDataZonas;
      this.fillData();
    }

    this.getDataZonas();
  },
  data () {
    return {
      indicador: {},
      coords: null,
      arrayRasters: [],
      datesToMapFormated: [],
      datesToMap: [],
      wk: null,
      urlGeoServer: null,
      arrayRastersFiltered: [],
      arrayDatesToMapFiltered: [],
      leyenda: [],
      showBottonBackMunicipio: false,
      idMunicipio: null,
      fechaIniFiltered: null,
      fechaFinFiltered: null,
      fechaInicioMunicipal: null,
      fechaFinMunicipal: null,
      showDialog: false,
      msgDialog: '',
      arrayZonas: [],
      unidadMedidaIndicador: '',
      datosObjetivo: null
    };
  },
  mounted () {
    this.$eventHub.$on('filterRangeOfDates', (fechaInicial, fechaFinal) => {
      this.fechaIniFiltered = fechaInicial;
      this.fechaFinFiltered = fechaFinal;
      this.filterMap(fechaInicial, fechaFinal);
      this.getDataZonas();
    });
  },
  methods: {
    formatNameZona (name) {
      var nameArray = name.split('_');
      return nameArray[1];
    },
    checkSomeItemWithNombre () {
      let haveName = false;
      this.dataIndicador.leyenda.forEach(item => {
        if (item.nombre && item.nombre !== ' ') {
          haveName = true;
        }
      });
      return haveName;
    },
    isNegativeNumber (number) {
      return number < 0;
    },
    async getDataZona (showButtonBackMunicipio, idZona, clickMap = false) {
      await this.$store.dispatch(
        types.ACTION_GET_INDICADOR_ZONA, { idIndicador: this.dataIndicador.id, idCiudad: this.ciudadSelected.id, idZona: idZona }
      ).then((resp) => {
        // se comprueba si hay datos, en caso de no haberlos se mantienen los datos de la anterior zona
        if (this.filterChartZone(resp)) {
          this.showBottonBackMunicipio = showButtonBackMunicipio;
          this.indicador = resp;
          this.changeCoords(clickMap, resp);

          this.changeDatesZone(resp);

          this.checkFechaFiltered();
        } else {
          this.msgDialog = 'No hay datos disponibles para el rango seleccionado';
          this.showDialog = true;
        }
      });
    },
    changeDatesZone (resp) {
      let condition = resp.datosGraficaMunicipal.valoresGrafica && resp.datosGraficaMunicipal.valoresGrafica.length > 0;
      this.arrayRasters = condition ? this.fillArrayRaster(resp) : [];
      this.datesToMap = condition ? this.fillDates(resp) : [];
      this.datesToMapFormated = condition ? this.fillFormatDates(resp) : [];
    },
    checkFechaFiltered () {
      if (this.fechaIniFiltered === null && this.fechaFinFiltered === null) {
        this.filterMap(this.fechaInicioMunicipal, this.fechaFinMunicipal);
      } else {
        this.filterMap(this.fechaIniFiltered, this.fechaFinFiltered);
      }
    },
    changeCoords (clickMap, resp) {
      if (clickMap === false) {
        let coords = { maximumLatitude: resp.limitesMunicipio.maximumLatitude,
          maximumLongitude: resp.limitesMunicipio.maximumLongitude,
          minimumLatitude: resp.limitesMunicipio.minimumLatitude,
          minimumLongitude: resp.limitesMunicipio.minimumLongitude };
        this.changeCoordsMap(coords);
      }
    },
    filterChartZone (dataZona) {
      let result = null;
      if (this.fechaIniFiltered === null && this.fechaFinFiltered === null) {
        result = this.filterChart(this.fechaInicioMunicipal, this.fechaFinMunicipal, dataZona.datosGraficaMunicipal.valoresGrafica);
      } else {
        result = this.filterChart(this.fechaIniFiltered, this.fechaFinFiltered, dataZona.datosGraficaMunicipal.valoresGrafica);
      }
      return result;
    },
    filterChart (fechaInicial, fechaFinal, dataZona) {
      let posInicial = this.filterDateIniChart(fechaInicial, dataZona);
      let posFinal = this.filterDateFinChart(fechaFinal, dataZona);
      if (posInicial !== -1 && posFinal !== -1 && posFinal >= posInicial) {
        return true;
      } else {
        return false;
      }
    },
    filterDateIniChart (fechaInicial, dataZona) {
      let posInicial = -1;
      for (let i = 0; i < dataZona.length && posInicial === -1; i++) {
        let dateIniSimple = dataZona[i].date.split('T');
        if ((moment(dateIniSimple[0]).format('YYYY/MM/DD')) >= fechaInicial) {
          posInicial = i;
        }
      }
      return posInicial;
    },
    filterDateFinChart (fechaFinal, dataZona) {
      let posFinal = -1;
      for (let i = dataZona.length - 1; i >= 0 && posFinal === -1; i--) {
        let dateFinSimple = dataZona[i].date.split('T');
        if ((moment(dateFinSimple[0]).format('YYYY/MM/DD')) <= fechaFinal) {
          posFinal = i;
        }
      }
      return posFinal;
    },
    fillData () {
      this.wk = process.env.VUE_APP_WK;
      this.urlGeoServer = process.env.VUE_APP_URLGEOSERVER;
      this.coords = { maximumLatitude: this.dataIndicador.limitesMunicipio.maximumLatitude,
        maximumLongitude: this.dataIndicador.limitesMunicipio.maximumLongitude,
        minimumLatitude: this.dataIndicador.limitesMunicipio.minimumLatitude,
        minimumLongitude: this.dataIndicador.limitesMunicipio.minimumLongitude };
      let condition = this.dataIndicador.datosGraficaMunicipal.valoresGrafica && this.dataIndicador.datosGraficaMunicipal.valoresGrafica.length > 0;
      this.arrayRasters = condition ? this.fillArrayRaster(this.dataIndicador) : [];
      this.datesToMap = condition ? this.fillDates(this.dataIndicador) : [];
      this.datesToMapFormated = condition ? this.fillFormatDates(this.dataIndicador) : [];
      this.leyenda = this.dataIndicador.leyenda ? this.dataIndicador.leyenda : [];
    },
    fillArrayRaster (datos) {
      let arrayLayers = [];
      datos.datosGraficaMunicipal.valoresGrafica.forEach(e => {
        arrayLayers.push(e.layer);
      });
      return arrayLayers;
    },
    fillFormatDates (datos) {
      let arrayDates = [];
      datos.datosGraficaMunicipal.valoresGrafica.forEach(e => {
        let dateIniSimple = e.date.split('T');
        arrayDates.push(moment(dateIniSimple[0]).locale('es').format('MMM YY'));
      });
      return arrayDates;
    },
    fillDates (datos) {
      let arrayDates = [];
      datos.datosGraficaMunicipal.valoresGrafica.forEach(e => {
        arrayDates.push(e.date);
      });
      return arrayDates;
    },
    filterMap (fechaInicial, fechaFinal) {
      let posInicial = this.filterDateIni(fechaInicial);
      let posFinal = this.filterDateFin(fechaFinal);
      if (posInicial !== -1 && posFinal !== -1 && posFinal >= posInicial) {
        this.fillMapFiltered(posInicial, posFinal);
      } else {
        this.showDialogFilter = true;
      }
    },
    filterDateIni (fechaInicial) {
      let posInicial = -1;
      for (let i = 0; i < this.datesToMap.length && posInicial === -1; i++) {
        let dateIniSimple = this.datesToMap[i].split('T');
        if ((moment(dateIniSimple[0]).format('YYYY/MM/DD')) >= fechaInicial) {
          posInicial = i;
        }
      }
      return posInicial;
    },
    filterDateFin (fechaFinal) {
      let posFinal = -1;
      for (let i = this.datesToMap.length - 1; i >= 0 && posFinal === -1; i--) {
        let dateFinSimple = this.datesToMap[i].split('T');
        if ((moment(dateFinSimple[0]).format('YYYY/MM/DD')) <= fechaFinal) {
          posFinal = i;
        }
      }
      return posFinal;
    },
    fillMapFiltered (posInicial, posFinal) {
      this.arrayDatesToMapFiltered = [];
      this.arrayRastersFiltered = [];
      let arrayDates = [];
      let arrayRasters = [];
      for (let i = posInicial; i <= posFinal; i++) {
        let dateFinSimple = this.datesToMap[i].split('T');
        arrayDates.push(moment(dateFinSimple[0]).locale('es').format('MMM YY'));
        arrayRasters.push(this.arrayRasters[i]);
      }
      this.arrayRastersFiltered = arrayRasters;
      this.arrayDatesToMapFiltered = arrayDates;
    },
    aceptar () {
      this.showDialog = false;
    },
    updateHistoryZoneSelected (param) {
      this.getDataZona(true, param, true);
    },
    changeCoordsMap (coords) {
      this.coords = coords;
    },
    getDataZonas () {
      this.arrayZonas = [];
      let fechaIni = '';
      let fechaFin = '';
      if (this.fechaIniFiltered === null && this.fechaFinFiltered === null) {
        fechaIni = this.fechaInicioMunicipal;
        fechaFin = this.fechaFinMunicipal;
      } else {
        fechaIni = this.fechaIniFiltered;
        fechaFin = this.fechaFinFiltered;
      }
      this.$store.dispatch(types.ACTION_GET_CIUDAD_ZONAS,
        { idIndicador: this.dataIndicador.id,
          idCiudad: this.ciudadSelected.id,
          fechaInicio: moment(new Date(fechaIni)).format('YYYY-MM-DD'),
          fechaFin: moment(new Date(fechaFin)).format('YYYY-MM-DD')
        }).then(response => {
        this.dataIndicador.zonas.forEach(zona => {
          if (response.length > 0) {
            let zonaFinded = response.find(x => x.idZona === zona.id);
            if (zonaFinded !== undefined) zona['ultimoValor'] = zonaFinded.valor;
            else delete zona['ultimoValor'];
          }
          this.arrayZonas.push(zona);
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>

.marginTag{
  margin-top: 25px;
  height: auto;

  font-family: DINPro;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;

  .titleCard {
    margin: 0 0px 10px 4px;
    font-size: 20px;
    font-family: DINPro;
    font-weight: bold;
    letter-spacing: 0.29px;
    color: #474848;
  }
  .titleDesglose {
    font-size: 17px;
    letter-spacing: -0.68px;
    color: #454545;
    margin-bottom: 15px;
  }
  .rowDesglose {
    padding-right: 15px !important;
  }
  .desglose{
    margin-left:20px;
    margin-top: 10px;
    align-self: flex-end;
  }
  .desgloseText{
    font-size: 14px;
    letter-spacing: -0.56px;
    color: $azulOscuroZ;
    margin-right: 10px;
    font-weight: bold;
  }
  .q-icon{
    font-size: 2.5em;
    color: #808080;
  }
  .grafic{
    display: flex;
  }
  .grafico{
    margin-bottom: 120px;
  }
  .text-center{
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .divMap{
    height: 500px;
    // width: 50%;
  }
  .divLegend{
    height: auto;
    background-color: #f8f7f8;
    display: flex;
    padding-bottom: 15px;
  }
  .itemLegend{
    min-width: 20px;
    width: 12.5%;
    flex-direction: column;
    padding: 7px 0px 0px 7px;
    display: flex;
    justify-content:space-between;

  }
  .divLegend:last-child{
    padding-right: 7px;
  }

  .colorLegend{
    display: flex;
    width: 100%;
    height: 10px;
  }
  .imageLegend{
    margin-top: 5px;
    height: 61px;
  }
  .valueLegend{
    font-weight: bold;
    margin-bottom: 7px;
    margin-top: 7px;
    align-content: flex-start;
  }
  .noData{
    height: 500px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: -1.13px;
    color: $seafoam-blue-hover !important;
    align-items: center;
    display: flex;
    justify-content: center;
  }
}
.noDataDialog{
  font-family: DINPro;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -1.13px;
  color: $seafoam-blue-hover;
}
.zonaValor{
  color: #0093B2;
}

@media (max-width: 640px) {
  ::v-deep {
    .marginTag.q-card{
      padding-left: 7px;
      padding-right: 7px;
    }
  }
}

</style>
